import React from 'react';
import PropTypes from 'prop-types';
import {
  EmailViewSections,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/Sections';
import { FDPaper } from '@facet-wealth/design';
import { Dialogs } from './Dialogs';
import { EmailTabProvider } from './EmailTabContext';

export const EmailView = ({
  householdResource,
  meetingResource,
  meetingTemplateCollection,
  onSaveMeetingTemplate,
  openTabs,
  openTab,
  setActiveTab,
  className,
}) => {
  return (
    <EmailTabProvider
      meetingResource={meetingResource}
      householdResource={householdResource}
      meetingTemplateCollection={meetingTemplateCollection}
      openTabs={openTabs}
      onSaveMeetingTemplate={onSaveMeetingTemplate}
      setActiveTab={setActiveTab}
      openTab={openTab}
    >
      <div
        className={className}
        style={{
          height: '100%',
        }}
      >
        <FDPaper height={'100%'} padding={1} appearance={'flat'}>
          <EmailViewSections />
        </FDPaper>
      </div>
      <Dialogs />
    </EmailTabProvider>
  );
};

EmailView.propTypes = {
  className: PropTypes.string.isRequired,
  meetingTemplateCollection: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
  onSaveMeetingTemplate: PropTypes.func.isRequired,
  openTabs: PropTypes.func.isRequired,
  openTab: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};
